module.exports = __webpack_public_path__ + "img/zz.3d808f3a.jpg";